<template lang="pug">
div
  //- Hidden element for measurement
  div(ref="hiddenElementRef" :style="{ position: 'fixed', left: '-9999px', whiteSpace: 'nowrap' }")
    slot(name="hidden-items" :items="hiddenItems")
       y-chip.no-wrap(:label="`+${hiddenItems.length}`" text-color="neutral500" size="xs" outlined)
  //- Single flex container for visible items + hidden count
  div.items-container(ref="containerRef" :style="{ gap: `${gap}px` }")
    //- Visible items
    template(v-for="(item, index) in visibleItems")
      .visible-item(:key="`vi-${index}`")
        slot(name="visible-item" :item="item" :index="index")
          y-chip.no-wrap(:label="textItem ? item[textItem] : item" text-color="neutral500" size="xs" outlined)
    //- Hidden items count
    template(v-if="hiddenItems.length > 0")
      div.hidden-count(ref="tooltipAnchor" style="position: relative;")
        v-tooltip(top color="black" content-class="black tooltip-top-arrow" :attach="$refs.tooltipAnchor")
          template(#activator="{ on, attrs }")
            div.clickable(v-bind="attrs" v-on="on")
              slot(name="hidden-items" :items="hiddenItems")
                y-chip.no-wrap(:label="`+${hiddenItems.length}`" text-color="neutral500" size="xs" outlined)
          div(style="max-width: 30vw")
            ol.ml-n1
              template(v-for="(item, index) in hiddenItems")
                slot(name="hidden-item-tooltip" :item="item")
                  li.text-xs(:key="`hi-${index}`") {{ textItem ? item[textItem] : item }}
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    textItem: {
      type: String,
      default: null
    },
    gap: {
      type: Number,
      default: 12
    },
    offset: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      visibleItems: []
    }
  },
  computed: {
    hiddenItems () {
      return this.items.slice(this.visibleItems.length)
    },
    hiddenItemsDisplay () {
      return this.hiddenItems.length > 0 ? this.hiddenItems.join('\n') : ''
    },
    hiddenElementWidth () {
      return (this.$refs.hiddenElementRef?.offsetWidth || 0) + this.offset
    }
  },
  watch: {
    items: {
      deep: true,
      handler () {
        this.calculateVisibleItems()
      }
    }
  },
  mounted() {
    this.calculateVisibleItems()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    calculateVisibleItems() {
      const container = this.$refs.containerRef
      if (!container) return

      this.visibleItems = [...this.items]

      this.$nextTick(() => {
        // flex-wrap: wrap keeps container.offsetWidth constrained by parent
        const availableWidth = container.offsetWidth
        const itemElements = container.getElementsByClassName('visible-item')
        let totalWidth = 0
        let lastVisibleIndex = this.items.length

        // First pass: check if all items fit without hidden element width
        let allItemsWidth = 0
        for (let i = 0; i < itemElements.length; i++) {
          allItemsWidth += itemElements[i].offsetWidth
          if (i < itemElements.length - 1) {
            allItemsWidth += this.gap
          }
        }

        // If all items fit without truncation, show all items
        if (allItemsWidth <= availableWidth - this.offset) {
          this.visibleItems = [...this.items]
          return
        }

        // Otherwise, calculate with hidden element width reserved
        for (let i = 0; i < itemElements.length; i++) {
          totalWidth += itemElements[i].offsetWidth
          if (i < itemElements.length - 1) {
            totalWidth += this.gap
          }
          if (totalWidth > availableWidth - this.hiddenElementWidth - this.gap) {
            lastVisibleIndex = i
            break
          }
        }

        this.visibleItems = this.items.slice(0, lastVisibleIndex)
      })
    },
    handleResize() {
      this.calculateVisibleItems()
    }
  },
}
</script>

<style scoped>
.items-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
  max-height: 1.875rem;
}
.hidden-count {
  flex-shrink: 0;
}
</style>
